/** zh.js文件**/
module.exports = {
    // 首页
    home: {
        title: '营销管理系统',
        technical: '技术支持 : 刘书龙1',
        suggestion: '我有建议',
        userSwitch: '切换用户',
        logOut: '退出登录',
        qe: '快捷入口',
        ea: '活动申请',
        ed: '活动详情',
        EL: '活动列表',
        aff: '报备申请',
        regionalReporting: '区域报备申请',
        industryReporting: '行业报备申请',
        industryHeadReporting: '行业总部活动汇总表',
        industryTemplateReporting: '行业模板活动汇总表',
        RL: '报备列表',
        RD: '报备详情',
        iL: '行业报备列表',
        iD: '行业报备详情',
        rrL: '区域报备列表',
        rrD: '区域报备详情',
        hyzb: '行业总部活动汇总表',
        hymb: '行业模板活动汇总表',
        ca: '渠道申请',
        annualMarketingPlan: '年度营销规划',
        qa: '快捷申请',
        ai: '活动查询',
        db: '草稿箱',
        vr: '参观预约',
        hwd: '帮助文档',
        hd: '历史单据',
        pa: '待审批',
        Approved: '已审批',
        r: '被驳回',
        pf: '待反馈',
        pv: '待核销',
        vip: '核销中',
        empty: '空空如也~',
        cc: '线索中心',
        ntbp: '待处理数量',
        nof: '自行跟进数量',
        nos: '已挂起数量',
        nop: '已处理数量',
        coe: '活动日历',
        ra: '区域活动',
        ha: '总部活动',
        Mon: '一',
        Tue: '二',
        Wed: '三',
        Thu: '四',
        Fri: '五',
        Sat: '六',
        Sun: '日',
        AE: '追加费用',
        RAE: '报备追加费用',
        DoB: '预算详情',
        BP: '预算执行情况',
        BPP: '预算执行情况权限管理',
        single: '调单',
        LocP: '线索池列表',
        DoC: '线索详情',
        Pending: '待处理',
        Fuby: '自行跟进',
        Processed: '已处理',
        PutUp: '挂起',
        qddhbm: '2026-亚太大会报名'
    },
    // 新建申请
    newApp: {
        // 基本信息
        BasicInfo: {
            bi: '基本信息',
            target: '年度规划指标',
            an: '活动编号',
            bbbh: '报备编号',
            fs: '财务体系',
            toc: '货币种类',
            Applicant: '申请人',
            ci: '联系方式',
            ct: '签约类型',
            cn: '公司名称',
            at: '申请时间',
            cs: '对应销售',
            peuci: '请输入联系方式',
            pnfiw: '手机号格式有误',
            psafs: '请选择财务体系',
            psac: '请选择货币种类',
            pstcs: '请选择对应销售',
            Poa: '申请目的',
            Oc: '其他分类',
            ot: '其他类',
            AppClass: '申请分类',
            Pfitbu: '请填写业务单元',
            Pstapc: '请选择申请目的分类',
            ppl: '品推主导'
                // : "",
        },
        // 活动信息
        activityInfo: {
            ei: '活动信息',
            noa: '活动名称',
            bu: '业务单元',
            coa: '活动分类',
            foa: '活动形式',
            Organizer: '主办方',
            hdjd: '活动基地',
            jdlx: '基地联系方式',
            ht: '主办型',
            pt: '参与型',
            atomc: '协会/第三方机构主办/多方合办',
            tnoptbi: '拟邀请总人数',
            mta: '主要目标对象',
            toa: '活动类型',
            cms: '渠道会议细分',
            ps: '品推支持',
            hc: '举办城市',
            edoh: '预计举办日期',
            eed: '预计结束日期',
            hdcdtj: '活动场地查询',
            jma: '联合市场活动',
            ic: '国际渠道',
            cn: '渠道名称',
            csl: '活动分层',
            skca: '高层/关键客户活动',
            skcaP: '请选择是否高层/关键客户活动',
            hdmb: '活动目标',
            hdmbP: '请填写活动最终需达成的目标任务',
            otherTargetObject: '其它目标对象',
            otherTargetObjectP: '请输入其它目标对象',
            otherTargetObjectFormat: '其它（{content}）',
            cst: '渠道签约类型',
            dynags: '是否需要活动组支持',
            ba: '预算金额',
            ki: '关键举措',
            rpn: '远程POC名称',
            nofd: '精钻名称',
            noc: '圈子名称',
            tn: '样板名称',
            rp: '远程POC',
            jra: '联合精钻活动',
            ca: '圈子活动',
            mv: '样板参观',
            machineDemo: '样机演示/体验',
            psteeis: '请选择活动预计包含板块',
            IS: '所属行业方案',
            Industry: '所属行业',
            ActivityBgA: '活动背景&目的',
            Bitt: '活动背景/目的简单介绍',
            teietcs: '活动预计包含板块',
            artpl: '活动内容涉及产品线',
            desc: '注：线上总部活动需提前15天报备申请，线下活动需提前一个月报备申请，您未按时申请，请填写理由',
            pscst: '请选择渠道签约类型',
            psacn: '请选择渠道名称',
            psabu: '请选择业务单元',
            pstaacn: '请选择关联活动分类名称',
            tedcblttcd: '预计举办日期不能小于当前日期',
            tsdcbgtted: '开始日期不能大于结束日期',
            pepl: '请输入产品线',
            peteis: '请输入预计包含板块',
            peba: '请输入预算金额',
            petrfa: '请输入申请理由',
            peen: '请输入活动名称',
            psaac: '请选择活动分类',
            pstmt: '请选择主要目标对象',
            psao: '请选择主办方',
            pehc: '请输入举办城市',
            psaet: '请选择活动类型',
            pshdjd: '请选择活动基地',
            psjdlx: '请输入基地联系方式',
            psacms: '请选择渠道会议细分',
            psaef: '请选择活动形式',
            pettnop: '请输入活动总人数',
            psasd: '请选择开始日期',
            psaed: '请选择结束日期',
            psapl: '请选择产品线',
            perp: '请输入远程POC',
            pejda: '请输入联合精钻活动',
            peca: '请输入圈子活动',
            peastv: '请输入样板参观',
            psMachineDemo: '请输入样机演示/体验',
            Peacp: '请输入自定义产品',
            ta: '模板活动',
            Pstpote: '请选择活动目的',
            Psac: '请选择其他分类',
            Psyip: '请选择所属行业方案',
            Aan: '关联活动名称:',
            Tbicfta: '基础信息有未填写字段,请仔细检查',
            TypeM: '会议类',
            NoRL: '无报告环节',
            Psttoa: '请选择细分活动类型',
            tas: '活动工具包',
            dmp: '会腾微页面',
            QR: '微信二维码',
            title: '标题',
            comsc: '交流场景',
            Pscomsc: '请选择交流场景',
            strpr: '战略产品',
            Psstrpr: '请选择战略产品',
            agenda: '活动议程',
            Psagenda: '请选择活动议程',
            jkdh: '借款单号',
            jkje: '借款金额',
            wcxje: '未冲销金额',
            lczt: '流程状态',
            psps: '请选择品推支持',
            sfndghxshd: '是否年度规划线上活动',
            sfndghxshdTSY: '请选择是否年度规划线上活动',
            templateActivityName: '模板活动名称',
            headquarterActivityName: '总部活动名称'
        },
        // 拟邀请客户
        Customers: {
            ctbi: '拟邀请客户',
            psctbi: '请选择拟邀请客户',
            newBusOpp: '是否可能产生新建业务机会',
            ei: 'Excel导入',
            eu: 'Excel更新',
            dt: '下载模板',
            ac: '添加客户',
            ufsce1: '上传的文件大小不能超过10M',
            ahtci: '已有该客户信息',
            dnar: '请勿重复添加',
            CustomerName: '客户名称',
            ci: '客户身份',
            catt: '客户属性',
            bo: '业务机会',
            pbo: '推动业务机会',
            gjjl: '跟进记录',
            pdty: '当年是否产出',
            xqyz: '需求验证',
            khxq: '客户需求',
            isyxq: '是否有需求',
            yyz: '已验证',
            cc: '客户类别',
            bc: '必跟客户',
            ccd: '客户类别细分',
            ccon: '客户联系人',
            ccat: '联系人类别',
            cst: '渠道签约类型',
            noc: '圈子名称',
            wtb: '是否共建',
            cb: '已共建',
            ncc: '非共建',
            pecnpci: '请输入客户名称/省份/城市/行业',
            tctftrcn: '天眼查，点击可查询到真实的客户名称',
            bon: '业务机会名称',
            pecn: '请输入客户名称',
            psci: '请选择客户身份',
            pscr: '请选择客户需求',
            peabon: '请输入业务机会名称',
            pecc: '请输入客户联系人',
            psacc: '请选择联系人类别',
            pecst: '请输入渠道签约类型',
            pswtb: '请选择是否共建',
            psac: '请选择客户',
            tincmtsc: '没有找到与搜索条件相匹配的客户，您可以点击下方按钮自定义添加客户哦',
            ca: '自定义添加',
            nd: '暂无数据~,请在上方的输入框内输入您想要添加的客户名称进行客户搜索',
            Pecu: '请输入客户单位',
            Petcea: '请输入正确的邮箱地址',
            crmkh: ' crm客户',
            psfiw: '请输入手机号'
            // 客户属性
            // : "",
        },
        // 活动目录
        Catalogue: {
            t: '活动目标',
            zrs: '拟邀请（覆盖）总人数',
            dws: '拟邀请（覆盖）目标单位数',
            create3m: '预计3个月内新建业务机会数',
            push3m: '预计3个月内推动业务机会数',
            create3mAmount: '预计3个月内新建业务机会金额(万)',
            push3mAmount: '预计3个月内推动业务机会金额(万)',
            pzrs: '请输入拟邀请总人数',
            pdws: '请输入拟邀请目标单位数',
            pcreate3m: '请输入预计3个月内新建业务机会数',
            ppush3m: '请输入预计3个月内推动业务机会数'
        },
        // 费用归属
        Attribute: {
            rjfyys: '人均费用预算',
            dchdfysx: '费用要求',
            rjfyystsy: '请输入人均费用预算',
            dchdfysxtsy: '请填写单场费用上限和人均费用上限',
            aoe: '费用归属',
            None: '若没有您需要归属部门或者费用类型，您可联系区域对应品推咨询。',
            Ntwo: '若没有您需要归属部门或者费用类型，您可让对应销售联系区域对应品推咨询。',
            aca: '添加费用归属',
            tc: '费用合计（自动生成）',
            hdfyzj: '活动费用总计',
            hdfybz: '活动费用明细备注',
            fygsbz: '费用归属备注',
            qxd: '去下单',
            ggfyzj: '广告品费用总计',
            psca: '请选择费用归属',
            pspar: '请选择重点参会/落地区域',
            tao: '费用金额不能大于报备金额',
            pstcad: '请选择费用归属部门',
            psaft: '请选择费用类型',
            psams: '请选择细分市场',
            bppsapl: '品牌推广部请选择产品线',
            ffna: '不可编辑活动费用',
            ndc: '不可编辑广告品费用',
            srmf: 'SMB区域市场基金',
            metc: '营销费用-模板活动',
            cad: '费用归属部门',
            toe: '费用类型',
            at: '活动申请时间',
            bat: '报备时间',
            bb: '预算余额',
            ms: '细分市场',
            pl: '产品线',
            ac: '活动费用',
            coam: '广告品费用',
            aa: '申请金额',
            bbje: '报备金额',
            psbbje: '请填写报备金额',
            roha: '总部活动报备',
            DueTT: '因近期礼品库切换，故被驳回、召回修改的单据需重新选择商品下单。系统给您带来的不便敬请谅解！',
            dcoa: '活动费用明细',
            tp: '计划总计',
            aar: '添加一行',
            pspc: '请选择项目内容',
            ttafcb0: '申请的总费用不能为0',
            pc: '项目内容',
            pup: '计划单价',
            nop: '计划数量',
            sp: '计划小计',
            breakdownAdvertising: '广告品费用明细',
            OrderNumber: '订单号',
            TotalCcosts: '费用合计',
            Borrowing: '1、当期日期晚于活动预计结束日期不可借款；2、费用核销中不可借款。',
            WriteOff: '只有费用申请人才可以核销。',
            Revoke: '该活动包含广告品，不可以撤销，请核销广告品费用；该费用正在核销中，不允许撤销；只有申请人和审批流程上的品推专员以及拓展经理才可以撤销；您有未冲销的借款，不可以撤销活动。',
            WriteOffInfo: '市场活动单据进行跨年核销，需邮件说明情况。行业费用请发送：行业总经理；区域费用请发送：区域主管。SBG请抄送：SBG-焦梦颖、IT-刘书龙，其它部门请抄送：品推-齐雪鹏、IT-刘书龙。主管邮件回复【同意核销】后，方可进行活动单据跨年核销。',
            RevokeInfo: '该费用包含礼品订单，暂不支持在活动系统直接取消，请联系礼品汇人工客服处理该订单后返回本系统取消该费用',
            WriteOffCheck: '合规流程未完成，请在下方合规资料附件处上传合规资料并提交发起审批，合规审批完成后再发起核销'
        },
        // 广告品列表
        ADList: {
            loai: '广告品列表',
            mc: '我的选择',
            rss: '锐捷自供',
            Ep: '电商商品',
            pewtsf: '请输入要搜索的内容',
            Category: '分类:',
            Am: '更多',
            Stock: '库存',
            isEmpty: '空空如也~',
            inoia: '添加商品数量有误',
            tpisafsita: '该商品在该区域不可售',
            pari: '请添加地区信息',
            pfitriac: '请认真填写收货信息和核对广告品信息',
            ri: '收货信息',
            na: '新建地址',
            da: '默认地址',
            Collapse: '收起',
            Address: '地址',
            AddMana: '地址管理',
            OE: '普通快递',
            SfAir: '顺丰航空到付',
            SfE: '顺丰公路到付',
            Pictures: '图片',
            noa: '广告品名称',
            up: '单价',
            jhnum: '计划数量',
            jhprice: '计划小计',
            no: '数量',
            sm: '发运方式',
            ss: '单独发运',
            fcpos: '跟随客户采购订单发运',
            Subtotal: '小计',
            ctc: '继续选择',
            gong: '共 ',
            atoxxa: ' 件广告品',
            Total: '合计',
            csbii: '当前库存余数不足',
            psap: '请选择商品',
            Cdota: '确认删除该地址',
            DeleAdd: '删除地址',
            Dwtstaatda: '确定是否将该地址设为默认地址',
            Sada: '设为默认地址',
            Aa: '地址区域',
            Da: '详细地址',
            Mp: '手机',
            Peacp: '请输入联系人',
            psaat: '请选择地址类型',
            Peypn: '请输入手机号',
            Psap: '请选择省份',
            Psaci: '请选择城市',
            Psaco: '请选择区县',
            Psas: '请选择街道/镇',
            Pefa: '请输入详细地址',
            Psacou: '请选择国家',
            Province: '省份',
            City: '城市',
            DC: '区县',
            St: '街道/镇',
            At: '地址类型',
            Regional: '大区',
            Area: '区域',
            CreationTime: '创建时间',
            InviteSourceName: '邀请来源',
            ContactQuality: '联系人信息质量',
            CustomerUnit: '客户单位',
            ContactNumber: '联系电话',
            Email: '邮箱',
            Industry: '行业',
            Domestic: '国内',
            International: '国际',
            Country: '国家',
            Sad: '设为默认',
            Sales: '销售',
            SalerName: '销售名称',
            xqcp: '需求产品',
            xpms: '需求描述'
                // : "",
        },
        // 拟邀请客户统计
        inviteCustomer: {
            ca: '客户属性',
            noocc: '老客户单位数量',
            noucc: '陌生客户单位数',
            nolcc: '列名客户单位数',
            noncc: '非列名客户单位数',
            nocfuc: '陌生渠道单位数',
            nolccx: '列名渠道单位数',
            nonlcc: '非列名渠道单位数',
            contactCompletionRate: '联系人信息完整率',
            contactExceptionCount: '联系人信息异常个数',
            tbps: '目标业务机会推动个数',
            contactCompletionRateInfo: '联系人信息完整率=联系人信息完整数/联系人信息总数*100%\n联系人信息完整说明：客户联系人、联系电话、邮箱三个信息均无缺失、无错误',
            contactExceptionCountInfo: '客户联系人、联系电话、邮箱三个信息存在缺失/错误'
        },
        Ycon: '您即将取消该活动报备，请确认！'
    },
    // 活动列表
    eventList: {
        AppStatus: '审批状态',
        AppDepa: '申请部门',
        Ms: '物料状态',
        BIFind: 'BI智能分析平台',
        Configured: '已配置',
        NotCon: '未配置',
        ActCode: '活动编码',
        Afc: '申请通道',
        Department: '部门',
        Me: '营销费用',
        QC: '品推专员',
        Doi: '重要程度',
        NotEva: '未评估',
        Feasibility: '可执行性',
        Sos: '支持力度',
        Revoke: '撤销',
        Rc: '召回修改',
        AppPro: '审批流程',
        Fad: '费用归属部门（点击查看审批详情）',
        EAAF: '活动申请审批流',
        AvAf: '活动核销审批流',
        Taoa: '活动总金额',
        Psaem: '请选择活动负责人',
        Peac: '请输入审批意见',
        Yanaafte: '您不是活动的申请人无法召回',
        OKRMta: '确定召回修改该活动?',
        qdzhxam: '确定召回修改?',
        PsaeiuFA: '已撤销的费用归属',
        Aysywtctf: '费用撤销后将归还费用预算，确定撤销该费用吗？',
        bbzsqcxtsy: '撤销活动后将会归还预算，并也会撤销对应的活动报备单据，请确认是否继续撤销活动?',
        qdcxgfym: '确定撤销该费用吗？',
        qdcxgfymhd: '撤销活动后将会归还预算，并也会撤销对应的活动报备单据，请确认是否继续撤销活动。',
        FeeAA: '费用申请金额',
        Tsosro: '系统仅支持流程中单个费用归属的召回操作',
        Position: '职务',
        PR: '采购申请',
        VPR: '查看采购记录',
        Aore: '已撤销的费用归属',
        Acie: '广告品费用为空',
        Iehnyetp: '本场活动尚未录入参会人，是否现在录入?',
        SPV: '服务商核销',
        CI: '收款信息',
        Print: '打印',
        Doa: '活动明细',
        Tac: '实际费用总计',
        Au: '附件上传',
        Uei: '上传电子发票',
        NonI: '非发票（上传合同、账单等其他附件）',
        Pctpi: '请完善收款信息',
        Peaup: '请输入实际单价',
        Peaq: '请输入实际数量',
        PaymentType: '付款类型',
        BanName: '银行账户名',
        Pwtbil: '银行所在省/直辖市',
        Cwtbil: '银行所在市',
        Aob: '开户支行',
        Psyp: '请选择所在省/直辖市',
        Ban: '银行账号',
        TIn: '税号',
        Aup: '实际单价',
        ActualN: '实际数量',
        ActualS: '实际小计',
        Psyb: '请选择开户银行',
        Pstpwtbil: '请选择银行所在省',
        Pstcwtbil: '请选择银行所在市',
        BankPayment: '银行打款',
        AccountType: '账户类型',
        ExternalUnit: '外部单位',
        AccountBank: '开户银行',
        CustomerInfo: '客户信息',
        Psaec: '请选择导出的客户',
        Austdtc: '确定删除客户?',
        Austdtsc: '是否确定删除此客户，删除后该客户将不计入实际参会名单中',
        Psactc: '请选择要关闭的客户',
        LoanAmount: '借款金额',
        PaymentDate: '用款日期',
        RepaymentDate: '还款日期',
        ContractNumber: '合同编号',
        Dotuof: '用款情况说明',
        Tdpiii: '该单据参与计息，计息利率（日息）：',
        ReceiptInfo: '收款信息',
        Mop: '付款方式',
        ReceivingUnit: '收款单位',
        Pepnopn: '请输入收款人名字或收款单位名称',
        AccountNumber: '账号',
        BranchName: '支行名称',
        Pfitla: '请填写借款金额',
        psapd: '请选择用款日期',
        Pfitpi: '请填写用款情况说明',
        Psaat: '请选择账户类型',
        Psapu: '请选择收款单位',
        InternalStaff: '内部员工',
        ExternalInd: '外部个人',
        TaufitliPcc: '借款信息有未填写字段,请仔细检查',
        Petoetn: '请输入原始活动单号'
            // : "",
    },
    // 审批中心
    approvalCenter: {
        copoa: '申请目的分类',
        ReportActivity: '活动报备',
        ComplianceApplication: '合规申请',
        ActivityApplication: '活动申请',
        ActivityNumber: '活动编号',
        EventName: '活动名称',
        TypeOfActivity: '活动类型',
        TheApplicant: '申请人',
        ExpenseDepartment: '费用部门',
        TypeFee: '费用类型',
        AnnualBudget: '年度预算（元）',
        BalanceBudget: '预算余额（元）',
        NumberApprovals: '您已审批场次',
        AmountApprovals: '您已审批金额',
        _NumberApprovals: '您待审批场次',
        _AmountApprovals: '您待审批金额',
        CorrespondingSales: '对应销售',
        Department: '申请部门',
        TimeApplication: '申请时间',
        MarketingExpenses: '营销费用',
        DegreeImportance: '重要程度',
        AbilityExecute: '可执行性',
        StrengthSupport: '支持力度',
        ToDealWith: '去处理',
        StatusMaterial: '物料状态',
        ConsentBulk: '批量同意',
        AttributionExpenses: '费用归属',
        MarketSegmentation: '细分市场',
        AmountApplication: '申请金额',
        CostActivities: '活动费用',
        CostAdvertisingDoods: '广告品费用',
        TotalBudget: '预算总额',
        ReasonsApplication: '申请原因',
        MaterialMoving: '活动物料',
        FOE: '执行反馈',
        ActivityQuality: '活动质量',
        PCU: '参会客户单位',
        SyncCRM: '同步CRM',
        SyncCRMSuccess: '同步成功！',
        PromptMsg1: '您尚未录入参会客户单位，无法提交执行反馈，是否前往录入?',
        PromptMsg2: '请至少选择一个前期支持',
        PromptMsg3: '请至少选择一个后期支持',
        PromptMsg4: '实际参会人数必须大于0，请录入参会客户单位',
        PromptMsg5: '暂无数据~，请在上方的输入框内输入您想要添加的客户名称进行客户搜索',
        PromptMsg6: '没有找到与搜索条件相匹配的客户，您可以点击下方按钮添加为新数据哦~',
        ActualStartDate: '实际举办开始日期',
        ActualEndDate: '实际举办结束日期',
        ppss: '品推支持情况',
        anop: '实际参会人数（不含内部员工）',
        anop1: '实际参会人数（不含内部员工）-会腾获客数',
        jaon: '是否联合活动',
        hydaq: '是否做了问卷',
        KOL: 'KOL站台/样板客户分享',
        Demo: '样机演示/体验',
        iaon: '是否重要活动',
        sdat: '选择日期时间',
        ass: '活动支持情况',
        ess: '前期支持',
        oss: '现场支持',
        jspc: '联合的服务商/渠道',
        rfncq: '未收集问卷的原因',
        noqc: '回收问卷数',
        nosl: '销售线索条数',
        oan: '原始活动单号',
        fp: '反馈人',
        tof: '反馈时间',
        lmt: '最近一次修改时间',
        pswtja: '请选择是否联合活动',
        psic: '请选择是否国际渠道',
        pswtdtqon: '请选择是否做了问卷',
        pskol: '请选择KOL站台/样板客户分享',
        psmd: '请选择样机演示/体验',
        psaia: '请选择是否重要活动',
        pstpps: '请选择品推情况',
        toc: '客户类型',
        tyc: '天眼查',
        ceog: '客户录入操作指南',
        PsaeiuFA: '请选择费用归属下的费用项',
        EventManager: '活动负责人',
        Psaem: '请选择活动负责人',
        Peac: '请输入审批意见',
        AppCom: '审批意见',
        ActivityCustomerVOCLink: '活动客户VOC记录链接'
    },
    // 按钮
    btn: {
        Close: '关闭',
        Open: '开启',
        BS: '批量关闭',
        EC: '导出客户',
        Export: '导出',
        OverviewExport: '总览导出',
        DetailExport: '明细导出',
        New: '新增',
        Edit: '编辑',
        Create: '新建',
        Delete: '删除',
        Submit: '提交',
        Cancel: '取消',
        OK: '确定',
        Add: '添加',
        Return: '返回',
        Discard: '废弃',
        SaveD: '保存草稿',
        CancelFil: '取消报备',
        TransferApp: '转申请',
        Reset: '重置',
        Search: '搜索',
        CollspseS: '收起搜索',
        AdvancedS: '高级搜索',
        Revoke: '撤销',
        Borrowing: '借款',
        WriteOff: '核销',
        Doc: '核销详情',
        RecallC: '召回修改',
        zh: '召回',
        ActivityE: '活动评估',
        Agree: '同意',
        Rejected: '驳回',
        BatchDel: '批量删除',
        BatchAdd: '批量添加',
        View: '查看',
        Yes: '是',
        No: '否',
        Modify: '修改'
            // : "",
    },
    // 通用
    general: {
        new: '新',
        ps: '请选择',
        peak: '请输入关键词',
        psad: '请选择日期',
        cbe: '不能为空',
        pec: '请输入内容',
        yes: '是',
        no: '否',
        Client: '客户',
        Ocus: '老客户',
        Ncus: '新客户',
        Channel: '渠道',
        media: '媒体',
        Rjis: '锐捷内部员工',
        msch: '营销系统渠道',
        mscu: '营销系统客户',
        md: '营销数据库',
        Other: '其他',
        All: '全部',
        fujian: '福建',
        Operation: '操作',
        fd: '精钻',
        cp: '联系人',
        Uploader: '上传人',
        Note: '注',
        Remarks: '备注',
        Hint: '提示',
        NoData: '暂无数据',
        ctView: '点击查看',
        AppRules: '申请规则',
        SubSucc: '提交成功',
        SaveSucc: '保存成功',
        AddSucc: '添加成功',
        EditSucc: '编辑成功',
        DeleSucc: '删除成功',
        SetupSucc: '设置成功',
        OperSucc: '操作成功',
        ModSucc: '修改成功',
        ImpSucc: '导入成功',
        AppSucc: '审批成功',
        SuccLoan: '借款成功',
        EventsEditor: '活动编辑',
        ReportEditor: '报备编辑',
        OKSad: '请确定保存为草稿，如不保存填写的活动数据将被清空',
        BasicInfo: '基础信息',
        End: '结束',
        Status: '状态',
        Man: '男',
        Women: '女',
        PsDi: '请选择删除项',
        Aystdtd: '确定删除此草稿?',
        SaveTime: '保存时间',
        Download: '下载',
        Preview: '预览',
        jump: '跳转',
        Normal: '正常',
        Failure: '失效',
        undone: '已撤销',
        Rejected: '已驳回',
        ClickEnter: '点击输入',
        CEtsbn: '点击输入，可通过名字搜索',
        CE_awysN: '点击输入，（选择否的时候出现）',
        ServerError: '服务器错误',
        StartTime: '开始时间',
        EndTime: '结束时间',
        ExportSuccess: '导出成功',
        ExportFailure: '导出失败',
        Loading: '加载中...'
            // : "",
    },
    // 文件
    file: {
        Annex: '附件',
        aa: '活动附件',
        xa: '相关附件',
        Na: '附件名称',
        F10M: '支持最大文件10M',
        F50M: '支持最大文件50M',
        ctu: '点击上传',
        Fuf: '文件上传失败',
        Fus: '文件上传成功',
        Fds: '文件删除成功',
        FPdar: '文件上传失败，请删除重新上传',
        FPdaua: '文件上传失败，请删除重新上传',
        uFn10M: '上传的文件大小不能超过10M',
        uFn50M: '上传的文件大小不能超过50M',
        ImportCustomers: '导入客户',
        CustomerInfoIT: '客户信息导入模板',
        CustomerInfoIEX: '客户信息更新模板',
        SupFF: '支持文件格式：.xls .xlsx',
        Ctdtt: '点击下载模板',
        FileU: '文件上传',
        UploadTime: '上传时间',
        Limit1: '当前限制选择 3 个文件，本次选择了 ',
        Limit2: ' 个文件，共选择了 ',
        Limit3: ' 个文件',
        fileName: '文件名称',
        DocumentName: '文档名称',
        hdzlfj: '合规资料附件'
            // : "",
    },
    // 通知说明
   // 通知说明
    notic: {
        NOTIC: '通知',
        FXINFO: '风险提示',
        NOTICContent: '2022年营销活动平台关闭通知',
        tcuafc: '您申请的活动中含有广告品订单，由于电商原因，订单7天后会失效，请您确保活动单在7天内完成审批。',
        AppRule: '申请规则说明',
        AppRuleOne: '合作伙伴申请活动需提前15天在系统申请以便资源（费用、人员、内容工具等）合理规划与投入; 如未按规定提前申请，将无法获得人员、内容工具等支持。',
        AppNotic: '每月20日-30/31日为次月活动报备周期，剩余时间无法进行报备，如遇临时突发活动请与费用负责人沟通同意后，通过活动申请通道申请活动',
        zhinfo: '请您确认以上信息是否准确，如果准确点击下方确认按钮提交申请，如果信息有误，点击修改按钮进行信息的修改~',
        ActivityNotice: '活动提交成功，是否需要跳转市场资料库，查看相关活动资料?',
        addUserErrA: '您要添加的客户存在未选择业务机会和是否可能产生新建业务机会的客户，确认是否继续添加？',
        addUserErrB: '您要添加的客户存在未选择业务机会，确认是否继续添加？',
        addUserErrC: '您要添加的客户存在未选择是否可能产生新建业务机会的客户，确认是否继续添加？',
        applicationUpload: '目标值为0,数据作为活动审批的重要依据,确认是否继续提交,或返回修改',
        costinfo: '活动申请费用为0，是否继续提交，提交后将会释放报备金额并归还预算',
        create3m: '新建业务',
        push3m: '推动业务',
        and: '和',
        hgtsinfo: '请上传经过合规自查和业务线确认的活动资料，包括PPT、海报、内容脚本等。',
        witeOffInfo: '请确认是否发起核销'
        // : "",
    },
    // 活动申请配置
    ruleConfig: {
        ruleSort: '规则排序',
        createUser: '创建人',
        addDialogTitle: '新增活动申请配置',
        editDialogTitle: '编辑活动申请配置',
        conditionName: '条件名称',
        conditionValue: '对应值',
        addCondition: '添加条件',
        addFieldTitle: '添加字段'
    },
    // 活动质量
    activityQuality: {
        // 核心结果数据
        coreResultData: '核心结果数据',
        // 实际参会人数(不含内部员工人数)
        actualAttendanceNum: '实际参会人数(不含内部员工人数)',
        // 实际到会目标单位数(单位数)
        actualTargetUnitNum: '实际到会目标单位数(单位数)',
        // 联系人信息完整率
        contactInfoCompletionRate: '联系人信息完整率',
        // 实际新建业务机会数(个数)
        actualNewBusinessNum: '实际新建业务机会数(个数)',
        // 实际推动业务机会数(个数)
        actualPushBusinessNum: '实际推动业务机会数(个数)',
        // 愿意进一步交流客户单位数(单位)
        willingToExchangeCustomerUnitNum: '愿意进一步交流客户单位数(单位)',
        // 7天跟进单位数
        followUpUnitNum: '7天跟进单位数',
        // 实际新建业务机会金额(万元)
        actualNewBusinessAmount: '实际新建业务机会金额(万元)',
        // 实际推动业务机会金额(万元)
        actualPushBusinessAmount: '实际推动业务机会金额(万元)',
        tableColumn: {
            // 实际达成情况
            actualAchievementSituation: '实际达成情况',
            // 目标率
            targetRate: '目标率',
            // 实际率
            actualRate: '实际率',
            // 是否达标
            isAchieved: '是否达标',
            // 权重
            weight: '权重',
            // 实际值
            actualValue: '实际值',
            // 取值周期
            valueCycle: '取值周期',
            // 天
            days: '天',
            // 目标值
            targetValue: '目标值',
            // 预设目标
            presetTarget: '预设目标',
            // 实际达成
            actualAchievement: '实际达成',
            // 完成率
            completionRate: '完成率'
        },

        // 及时评估结果数据
        timelyAssessmentResultData: '及时评估结果数据',
        // 目标客户到会率(单位数)
        targetCustomerAttendanceRate: '目标客户到会率(单位数)',
        // 参会率(人数)
        attendanceRate: '参会率(人数)',
        // 愿意进一步交流率(单位数)
        willingToExchangeCustomerRate: '愿意进一步交流率(单位数)',

        // 个人预设目标完成情况
        personalPresetTargetCompletionSituation: '个人预设目标完成情况',

        // 单场活动质量评估
        singleActivityQualityAssessment: '活动质量评估',

        // 目标客户到会率
        targetCustomerAttendanceRate: '目标客户到会率',
        // 参会率
        attendanceRate: '参会率',
        // 愿意进一步交流率（单位）
        willingToExchangeCustomerRateUnit: '愿意进一步交流率（单位）',

        // 拟邀请人数
        plannedInviteNum: '拟邀请人数',
        // 实际参会人数
        actualAttendanceNum: '实际参会人数',
        // 拟邀请目标单位数
        plannedInviteUnitNum: '拟邀请目标单位数',
        // 实际到会目标单位数
        actualTargetUnitNum: '实际到会目标单位数',
        // 预计3个月内新建业务机会数
        plannedNewBusinessNum: '预计3个月内新建业务机会数',
        // 实际新建业务机会数
        actualNewBusinessNum: '实际新建业务机会数',
        // 预计3个月内推动业务机会数
        plannedPushBusinessNum: '预计3个月内推动业务机会数',
        // 实际推动业务机会数
        actualPushBusinessNum: '实际推动业务机会数',
        // 愿意进一步交流客户单位数（单位数）
        willingToExchangeCustomerUnitNum: '愿意进一步交流客户单位数',

        // 实际新建业务机会率（单位）
        actualNewBusinessRateUnit: '实际新建业务机会率（单位）',
        // 实际推动业务机会率（单位）
        actualPushBusinessRateUnit: '实际推动业务机会率（单位）',

        // 综合完成率
        comprehensiveCompletionRate: '综合完成率',

        // 愿意进一步交流客户单位数
        willingToExchangeCustomerUnitNumx: '愿意进一步交流客户单位数',
        // 参会的客户单位数
        actualAttendanceUnitNum: '参会的客户单位数',
        // 新建业务机会单位数
        actualNewBusinessUnitNum: '新建业务机会单位数',
        // 实际参会单位数
        actualAttendanceUnitNum: '实际参会单位数',
        // 推动业务机会的单位数
        actualPushBusinessUnitNum: '推动业务机会的单位数',
        // 参会CRM客户
        actualAttendanceCrmCustomerNum: '参会CRM客户'
    },
    industryReport: {
        hdxxName: '活动信息',
        zdnyqkf: '重点拟邀请客户',
        // 活动信息
        hdxx: {
            hdmc: '活动名称',
            yxzt: '营销主题',
            ywdy: '业务单元',
            yxxs: '营销形式',
            hdfl: '活动分类',
            mbhd: '模板活动',
            hdxs: '活动形式',
            zbf: '主办方',
            zymbdx: '主要目标对象',
            mbfgkhhx: '目标覆盖客户画像',
            yqf: '邀请方',
            gjsc: '关键市场',
            jbcs: '举办城市',
            mxqgfb: '是否面向全国发布',
            mxhy: '面向行业',
            yjjbzq: '预计举办周期',
            hdgjb: '活动工具包',
            gjjc: '关键举措',
            ybcg: '样板参观',
            hdsjcpx: '活动涉及产品线',
            zlcp: '战略产品',
            gjblj: '工具包链接'
        },
        // tsy
        hdxxtsy: {
            // 活动名称
            hdmc: '请输入活动名称',
            // 活动名称
            yxzt: '请输入营销主题',
            // 业务单元
            ywdy: '请输入业务单元',
            // 营销形式
            yxxs: '请选择营销形式',
            // 活动分类
            hdfl: '请选择活动分类',
            // 活动形式
            hdxs: '请选择活动形式',
            // 主办方
            zbf: '请选择主办方',
            // 主要目标对象
            zymbdx: '请选择主要目标对象',
            // 目标覆盖客户画像
            mbfgghhx: '请输入目标覆盖客户画像',
            // 邀请方
            yqf: '请选择邀请方',
            // 关键市场
            gjsc: '请输入关键市场',
            // 举办城市
            jbcs: '请输入举办城市',
            // 是否面向全国发布
            mxqgfb: '请选择是否面向全国发布',
            // 面向行业
            mxhy: '请选择面向行业',
            // 预计举办周期
            yqjbzq: '请选择预计举办周期',
            // 活动背景&目的
            hdbjmd: '请输入活动背景&目的',
            // 活动工具包
            hdgjb: '请输入活动工具包',
            // 关键举措
            gjjc: '请选择关键举措',
            // 活动涉及产品线
            hdsjcpx: '请选择活动涉及产品线',
            // 战略产品
            zlcp: '请选择战略产品',
            // 工具包链接
            gjblj: '请输入工具包链接',
            hjbxgcg: '工具包修改成功'
        },
        zdchqy: {
            name: '重点参会/落地区域',
            qymc: '区域名称',
            jycc: '建议场次',
            hj: '合计'
        },
        zdchqytsy: {
            qymc: '请输入区域名称',
            jycc: '请输入建议场次'
        },
         // 行业报备列表
        hybblb: {
            // 查询条件
            cxtj: {
                bbbh: '报备编码',
                hdmc: '活动名称/营销主题',
                yxfs: '营销形式',
                ffzq: '面向全国发布',
                sqr: '申请人',
                dyxs: '对应销售',
                bm: '部门',
                bbsj: '报备时间',
                hdgjb: '活动工具包',
                yxfy: '营销费用',
                shzt: '审批状态',
                bbr: '报备人',
                hy: '行业',
                nyqzrs: '拟邀请总人数',
                zdldqy: '重点落地区域',
                hybbr: '行业报备人',
                qymc: '区域名称',
                schd: '市场活动',
                szyx: '数字营销（内容营销）',
                hybb: '行业报备',
                qybb: '区域报备'
            },
            list: {
                bbbh: '报备编码',
                hdmc: '活动名称/营销主题',
                yxfs: '营销形式',
                ffzq: '面向全国发布',
                sqr: '申请人',
                dyxs: '对应销售',
                bm: '部门',
                bbsj: '报备时间',
                hdgjb: '活动工具包',
                yxfy: '营销费用',
                shzt: '审批状态',
                bbr: '报备人',
                hy: '行业',
                nyqzrs: '拟邀请总人数',
                zdldqy: '重点落地区域',
                hybbr: '行业报备人',
                qymc: '区域名称',
                mbkhhx: '目标客户画像',
                dcfysx: '费用要求',
                fyyq: '费用要求',
                rjfysx: '人均费用上限',
                zcc: '总场次',
                qybbzcc: '区域报备总场次',
                bbsptgcc: '报备审批通过场次',
                ysqcc: '已申请场次',
                bbzys: '报备总预算',
                bbzsqcc: '报备转申请场次',
                wbbsqcc: '未报备申请场次',
                sqzje: '预算占用金额',
                syksqje: '预算占用进度',
                bblx: '报备类型',
                ypz: '已配置',
                wpz: '未配置'
            },
            tsy: {
                bblx: '请选择报备类型',
                qxzdcw: '请至少选择一条数据'
            },
            // 报备详情
            bxxq: {
                jbxx: '基本信息',
                hdwl: '活动物料',
                hyzzyq: '行业自主邀请',
                qyyq: '区域邀约',
                gzj: '高职教',
                pj: '普教',
                yl: '医疗',
                qy: '企业',
                zw: '政府',
                aigc: 'AIGC',
                znbj: '智能建筑及ICT'
            }
        }
    },
    customerCalibration: {
      Title: {
        calibrationResult: '参会单位校准结果',
        crmSuggestedName: 'CRM建议客户',
        tycSuggestedName: '天眼查建议客户'
      },
      CountList: {
        customerCount: '客户单位总数',
        crmCustomerCount: 'CRM客户单位数',
        nonCrmCustomerCount: '非CRM客户单位数',
        accurateCustomerCount: '天眼查客户单位数',
        inaccurateCustomerCount: '非天眼查客户单位数',
        downloadDetail: '下载明细'
      },
      CustomerList: {
        customerName: '客户名称（双击改为CRM客户）',
        isCrmCustomer: '是否CRM客户',
        isAccurate: '是否天眼查客户',
        crmSuggestedName: 'CRM建议名称',
        tycSuggestedName: '天眼查建议名称',
        clickCalibration: '点击校准'
      },
      Info: {
        tip: '以下客户单位与CRM客户名称不一致，建议核对后再导入系统',
        warnningStart: '导入的客户单位，存在',
        warnningEnd: '个单位名称不准确的数据，是否继续导入',
        noData: '未查询到相似的客户名称，请点击客户名称校准！'
      }
    },
    exportCompliance: {
      startReview: '发起审查',
      detectError: '合规检测服务异常，请稍后重试',
      detectFailedPass: '合规检测失败，本次提交未经过合规校验，请知悉',
      detectFailedPrecheck: '合规检测失败，无法确认本次内容是否合规，是否继续提交？',
      warnDefault: '本次提交未通过合规校验',
      noEvidence: '缺少检测凭证，无法发起审查',
      interceptNo: '审查单号',
      reviewCreated: '审查单已创建',
      hitSubjects: '命中主体'
    }
};
